import React, { Fragment, useMemo, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CallId } from 'shared/models';

export type Props = {
    callId: CallId;
};

export const CallIdEventDetails = ({ callId }: Props) => {
    const { t } = useTranslation();

    const nodes = useMemo<ReactNode>(() => {
        const template = t('VIDEO.EVENT.CLID_DETAIL');
        
        const parts: ReactNode[] = [];
        template.replace(/([^<]*)(?:<([^>]+)\/>)?/g, (match, text: string, tag: string) => {
            if (text) {
                parts.push(
                    <span key={ parts.length.toString() }>
                        { text }
                    </span>
                );
            }
            if (tag === 'CALL') {
                parts.push(
                    <b key={ parts.length.toString() }>
                        { callId }
                    </b>
                );
            }
            return '';
        });
        return parts;
    }, [ callId, t ]);

    return (
        <Fragment>
            { nodes }
        </Fragment>
    );
};
